import React, { useEffect, useState } from "react";
import BoxApplication from "./BoxApplication";
import { Search } from "lucide-react"; // import search icon
import "./Panel.css";
import "./Application.css";

import FooterPanel from "../SectionsPanel/FooterPanel";

const Application = () => {
  const [applications, setApplications] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const res = await fetch("https://security-backend-1nbc.onrender.com/api/applicationsCollection");
        if (!res.ok) throw new Error("Failed to fetch applications");
        const data = await res.json();
        console.log("Fetched applications:", data);
        setApplications(data);
      } catch (err) {
        console.error("Error fetching applications:", err);
        setApplications([]);
      }
    };
    fetchApplications();
  }, []);

  // Filter applications by search
  const filtered = applications.filter((app) => {
    const fullName = `${app.first_name || ""} ${app.last_name || ""}`.toLowerCase();
    const searchTerm = search.trim().toLowerCase();
    return (
      fullName.includes(searchTerm) ||
      (app.email?.toLowerCase().includes(searchTerm)) ||
      (app.role?.toLowerCase().includes(searchTerm))
    );
  });

  return (
    <div className="page-container">
    <div className="panel-container">
      <div className="app-search-container">
        <Search className="app-search-icon" size={20} />
        <input
          type="text"
          placeholder="Search by name, email, or role"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="app-search-input"
        />
      </div>

      <div className="panel-boxes">
        {filtered.length === 0 && <div>No applications found.</div>}
        {filtered.map((app) => (
          <BoxApplication key={app.id} inquiry={app} />
        ))}
      </div>
    </div>
 {/* <FooterPanel/> */}
  </div>

  );
};

export default Application;

